<template>
  <div>
    <item-name :item="item" />

    <table class="w-full">
      <thead>
        <tr class="hidden sm:table-row">
          <th />
          <th
            v-for="col in item.meta.columns"
            :key="col.id"
            class="p-2 text-center"
          >
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <template v-for="(row, rowIndex) in item.meta.rows">
        <validation-provider
          :key="row.id"
          v-slot="{ errors }"
          :name="row.name"
          tag="tbody"
          :rules="validationRules"
          :class="{'bg-gray-800': rowIndex % 2 !== 0 }"
        >
          <tr class="-mx-4 dm:mx-0 block sm:table-row border border-gray-800">
            <td class="dm:mx-0 p-4 block sm:table-cell text-lg">
              <span class="text-bold">{{ row.name }}</span>
            </td>
            <td
              v-for="col in item.meta.columns"
              :key="col.id"
              class="p-4 block sm:table-cell sm:text-center border-l"
              :class="{'border-gray-900': rowIndex % 2 !== 0, 'border-gray-800': rowIndex % 2 === 0 }"
            >
              <label
                class="flex items-center w-full sm:justify-center"
              >
                <input
                  v-model="row.value"
                  :name="rowName(rowIndex)"
                  :value="col.id"
                  type="radio"
                  class="form-checkbox"
                  @change="updateRow(row.id, col.id)"
                >
                <span>
                  <span class="ml-4 sm:hidden">{{ col.name }}</span>
                </span>
              </label>
            </td>
          </tr>
          <tr v-if="errors.length > 0">
            <td :colspan="item.meta.columns.length + 1">
              <item-errors :errors="errors" />
            </td>
          </tr>
        </validation-provider>
      </template>
    </table>
  </div>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemName,
    ItemErrors
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  created () {
    if (!this.value) {
      this.value = this.item.meta.rows.map((row) => {
        return { 'row_id': row.id, 'column_id': null }
      })
    }
  },
  methods: {
    rowName (rowIndex) {
      return `${this.itemName}-row-${rowIndex}`
    },
    updateRow (rowId, columnId) {
      let valueIndex = this.value.findIndex(item => item.row_id === rowId)
      let value = this.value
      if (valueIndex !== -1) {
        value[valueIndex].column_id = columnId
        this.value = [...value]
      }
    }
  }
}
</script>
